import { HeartOutlined } from "@ant-design/icons";
import { Tooltip, Skeleton } from "antd";
import PropTypes from "prop-types";

import { useReferentialConditionRatings } from "@/entities/referential/referential-condition-ratings";

import "./ConditionRating.style.less";

const ConditionRating = ({ condition }) => {
  const { isLoading: isLoadingReferential, getReferentialAttr } =
    useReferentialConditionRatings();
  if (isLoadingReferential) {
    return <Skeleton.Avatar active={true} />;
  }

  const color = getReferentialAttr({ rating: condition }, "color");
  const title = getReferentialAttr({ rating: condition }, "name");

  return (
    <Tooltip title={title}>
      <div className="condition-rating" data-testid="condition-rating">
        <HeartOutlined className="condition-rating__icon" style={{ color }} />
        <span className="condition-rating__text" style={{ color }}>
          {condition}
        </span>
      </div>
    </Tooltip>
  );
};

ConditionRating.propTypes = {
  condition: PropTypes.string,
};

export default ConditionRating;
